import React from 'react'
import { Box } from '@mui/material'
import Button from './Button'
import CheckBox from './CheckBox'
import { DialogBody, DialogButtonRow } from './Dialog'

const sxContent = { p: '2rem' } as const

// Der Bestätigungsdialog beim Aktivieren einer Menü-Version. Bei einem Import muss Beyer Development
// erst bestätigen, ihn gegen die Speisekarte geprüft zu haben.
const MenuActivationDialogContent = ({
	title,
	description,
	confirmLabel,
	menuVersion,
	preview,
	isImport,
	onConfirm,
	dismissPortal,
}: {
	title: string
	description: string
	confirmLabel: string
	menuVersion: number
	preview: boolean
	isImport: boolean
	onConfirm: (menuVersion: number, preview: boolean, importChecked: boolean) => void
	dismissPortal: () => void
}): JSX.Element => {
	const [importChecked, setImportChecked] = React.useState(false)

	const handleConfirm = React.useCallback(() => {
		dismissPortal()
		onConfirm(menuVersion, preview, importChecked)
	}, [dismissPortal, onConfirm, menuVersion, preview, importChecked])

	return (
		<Box sx={sxContent}>
			<DialogBody title={title} description={description} />
			{isImport ? (
				<CheckBox
					label="Beyer Development hat den Import gegen die Speisekarte geprüft: Titel, Beschreibungen und Preise sind richtig übernommen."
					defaultValue={importChecked}
					onChange={setImportChecked}
				/>
			) : null}
			<DialogButtonRow>
				<Button m="0 1rem 0 0" onClick={dismissPortal}>
					Abbrechen
				</Button>
				<Button variant="outlined" onClick={handleConfirm} disabled={isImport && !importChecked}>
					{confirmLabel}
				</Button>
			</DialogButtonRow>
		</Box>
	)
}

export default React.memo(MenuActivationDialogContent)
